import { Component, OnInit } from '@angular/core';
import { buildNumber } from 'src/version';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  public buildNumber = buildNumber;
  constructor() {}

  ngOnInit(): void {}
}
